export const ADD_APPOINTMENT_TYPES = 'ADD_APPOINTMENT_TYPES'
export const ADD_APPOINTMENT_TYPE = 'ADD_APPOINTMENT_TYPE'
